import { BasicAuthServiceHelper } from '@/modules/Auth'
import APIRoutes from './APIRoutes'
import { flattenMapping, invertFlatMapping, transformObject } from './dataTransformer'

// Define a mapping between app keys and API keys
const transformationMap = {}

// Flatten the mapping
export const flatMap = flattenMapping(transformationMap)
export const reverseMap = invertFlatMapping(flatMap)

export const getCalendarAsync = async (date?: string) => {
  const { path: urlPath, method } = APIRoutes.GetCalendar

  // Conditionally build the URL with the date parameter if it's provided.
  const url = date ? `${urlPath}?date=${encodeURIComponent(date)}` : urlPath

  const getProfileResponse = (await BasicAuthServiceHelper.requestAuthenticatedAsync(url, method)) as {
    state: any
  }

  const transformedState = transformObject(getProfileResponse, reverseMap)

  return transformedState
}

export const getPetsitterCalendarAsync = async (id: string, date?: string, doNotAuthenticate?: boolean) => {
  const { path: urlPath, method } = APIRoutes.GetPetsitterCalendar(id)

  // Conditionally build the URL with the date parameter if it's provided.
  const url = date ? `${urlPath}?date=${encodeURIComponent(date)}` : urlPath

  const response = await BasicAuthServiceHelper.requestAuthenticatedAsync(
    url,
    method,
    undefined,
    undefined,
    doNotAuthenticate,
  )

  return response
}

export const addEventAsync = async (startDate: string, endDate: string, event: string) => {
  const { path, method } = APIRoutes.AddEvent
  const response = await BasicAuthServiceHelper.requestAuthenticatedAsync(path, method, {
    calendarEventType: event,
    startDate,
    endDate,
  })
  return response
}

export const deleteEventAsync = async (eventId: string) => {
  const { path, method } = APIRoutes.DeleteEvent(eventId)
  const response = await BasicAuthServiceHelper.requestAuthenticatedAsync(path, method)
  return response
}

export const updateMainEventAsync = async (data) => {
  const { path, method } = APIRoutes.UpdateMainEvent
  const response = await BasicAuthServiceHelper.requestAuthenticatedAsync(path, method, data)
  return response
}

export const getReservationCalendarAsync = async (reservationId: string) => {
  const { path, method } = APIRoutes.GetReservationCalendar(reservationId)
  const response = await BasicAuthServiceHelper.requestAuthenticatedAsync(path, method)
  return response
}
